module.exports = __webpack_public_path__ + "media/images/checkmark-78ad668d2805a64fbcf76580f03b5ff6.png";